import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	reorderFailureTitle: {
		id: 'spa-apps-sidebar-servicedesk.common.knowledge-item.hub-menu.reorder-failure-title',
		defaultMessage: "We couldn't reorder your categories",
		description: 'Title of flag displayed when category reordering fails',
	},
	reorderFailureDescription: {
		id: 'spa-apps-sidebar-servicedesk.common.knowledge-item.hub-menu.reorder-failure-description',
		defaultMessage: 'Please try again later.',
		description: 'Description in flag displayed when category reordering fails',
	},
	reorderMismatchTitle: {
		id: 'spa-apps-sidebar-servicedesk.common.knowledge-item.hub-menu.reorder-mismatch-title',
		defaultMessage: 'Successfully reordered categories',
		description:
			'Title of flag displayed when categories are successfully reordered, but somebody else has also made changes',
	},
	reorderMismatchDescription: {
		id: 'spa-apps-sidebar-servicedesk.common.knowledge-item.hub-menu.reorder-mismatch-description',
		defaultMessage:
			'Somebody else has also reordered the categories recently. Double check your category ordering.',
		description:
			'Title of flag displayed when categories are successfully reordered, but somebody else has also made changes',
	},
});
